import WebServiceRequest from "@/libs/Api/WebServiceRequest";

class GetAllGroupClass extends WebServiceRequest {
  constructor(context) {
    super(context);
    super.setTag("GroupClass/GetAllGroupClass");
  }
  setRequestParam(data) {
    super.setRequestParam(data);
  }
}

class CreateGroupClass extends WebServiceRequest {
  constructor(context) {
    super(context);
    super.setTag("GroupClass/CreateGroupClassByAdmin");
  }
  setRequestParamDataObj(data) {
    super.setRequestParamDataObj(data);
  }
}

class UpdateGroupClass extends WebServiceRequest {
  constructor(context) {
    super(context);
    super.setTag("GroupClass/UpdateGroupClassByAdmin");
  }
  setRequestParamDataObj(data) {
    super.setRequestParamDataObj(data);
  }
}

class DeleteGroupClass extends WebServiceRequest {
  constructor(context) {
    super(context);
    super.setTag("GroupClass/DeleteGroupClassBy");
  }
  setRequestParam(data) {
    super.setRequestParam(data);
  }
}

class GetASingleGroupClass extends WebServiceRequest {
  constructor(context) {
    super(context);
    super.setTag("GroupClass/GetByGroupClass");
  }
  setRequestParam(data) {
    super.setRequestParam(data);
  }
}

class GetAllGroupClassMasters extends WebServiceRequest {
  constructor(context) {
    super(context);
    super.setTag("GroupClass/GetAllGroupClassMastersByGroupClassId");
  }
  setRequestParam(data) {
    super.setRequestParam(data);
  }
}

class AssignMasterToGroupClass extends WebServiceRequest {
  constructor(context) {
    super(context);
    super.setTag("GroupClass/AssignMasterToGroupClass");
  }
  setRequestParam(data) {
    super.setRequestParam(data);
  }
}

class DeleteAMasterFromGroupClass extends WebServiceRequest {
  constructor(context) {
    super(context);
    super.setTag("GroupClass/DeleteGroupClassMasterById");
  }
  setRequestParam(data) {
    super.setRequestParam(data);
  }
}

class GetMasterAssignedGroupClasses extends WebServiceRequest {
  constructor(context) {
    super(context);
    super.setTag("GroupClass/GetDisableMasterGroupClassesByMasterId");
  }
  setRequestParam(data) {
    super.setRequestParam(data);
  }
}

class GetMasterUpdatedGroupClasses extends WebServiceRequest {
  constructor(context) {
    super(context);
    super.setTag("GroupClass/GetMasterGroupClassesByMasterId");
  }
  setRequestParam(data) {
    super.setRequestParam(data);
  }
}

class UpdateGroupClassByMaster extends WebServiceRequest {
  constructor(context) {
    super(context);
    super.setTag("GroupClass/UpdateGroupClassMasterByMaster");
  }
  setRequestParamDataObj(data) {
    super.setRequestParamDataObj(data);
  }
}

class UpdateGroupClassLink extends WebServiceRequest {
  constructor(context) {
    super(context);
    super.setTag("GroupClass/UpdateGroupClassMasterLinkByGroupClassMasterId");
  }
  setRequestParamDataObj(data) {
    super.setRequestParamDataObj(data);
  }
}

class CancelGroupClass extends WebServiceRequest {
  constructor(context) {
    super(context);
    super.setTag("GroupClass/CancelGroupClassesByGroupClassMasterId");
  }
  setRequestParam(data) {
    super.setRequestParam(data);
  }
}

class FinishGroupClass extends WebServiceRequest {
  constructor(context) {
    super(context);
    super.setTag("GroupClass/FinishGroupClassesByGroupClassMasterId");
  }
  setRequestParam(data) {
    super.setRequestParam(data);
  }
}

class GetMasterFinishedGroupClasses extends WebServiceRequest {
  constructor(context) {
    super(context);
    super.setTag("GroupClass/GetFinishedMasterGroupClassesByMasterToken");
  }
  setRequestParam(data) {
    super.setRequestParam(data);
  }
}

class GetMasterGroupStatusDetails extends WebServiceRequest {
  constructor(context) {
    super(context);
    super.setTag("GroupClass/GetGroupClassMasterStatusByGroupClassMasterId");
  }
  setRequestParam(data) {
    super.setRequestParam(data);
  }
}

class GetMasterGroupClassStudents extends WebServiceRequest {
  constructor(context) {
    super(context);
    super.setTag("GroupClass/GetAllGroupClassStudentsByGroupClassMasterId");
  }
  setRequestParam(data) {
    super.setRequestParam(data);
  }
}

class GetMasterIncomeFromGroupClasses extends WebServiceRequest {
  constructor(context) {
    super(context);
    super.setTag("GroupClass/GetMasterUserPaymentFromGroupClass");
  }
  setRequestParamDataObj(data) {
    super.setRequestParamDataObj(data);
  }
}

export {
  GetAllGroupClass,
  CreateGroupClass,
  UpdateGroupClass,
  DeleteGroupClass,
  GetASingleGroupClass,
  GetAllGroupClassMasters,
  AssignMasterToGroupClass,
  DeleteAMasterFromGroupClass,
  GetMasterAssignedGroupClasses,
  UpdateGroupClassByMaster,
  GetMasterUpdatedGroupClasses,
  UpdateGroupClassLink,
  CancelGroupClass,
  FinishGroupClass,
  GetMasterFinishedGroupClasses,
  GetMasterGroupStatusDetails,
  GetMasterGroupClassStudents,
  GetMasterIncomeFromGroupClasses,
};
